import { defineMessage, FormattedMessage, useIntl } from 'react-intl'
import { PadiModal } from '../helpers'

const projectsInfo = [
  {
    title: defineMessage({ defaultMessage: 'Beqa Adventure Divers, Fiji' }),
    subtitle: defineMessage({ defaultMessage: 'Marine Protected Areas' }),
    text: defineMessage(
      { defaultMessage: 'Working towards a more abundant Shark Reef Marine Reserve by tackling the impact that poaching during the pandemic had on local fish populations.' }),
    image: `${window.staticPath}travel_dist/images/offset-modal/team.jpg`,
    imageAlt: defineMessage({ defaultMessage: 'Beqa Adventure Divers' }),
  },

  {
    title: defineMessage({ defaultMessage: 'Florida Keys Dive Center, USA' }),
    subtitle: defineMessage({ defaultMessage: 'Marine Debris' }),
    text: defineMessage(
      { defaultMessage: 'Increasing Dive Against Debris training and cleanups, with a focus on the Florida Keys reef system.' }),
    image: `${window.staticPath}travel_dist/images/offset-modal/boat.jpeg`,
    imageAlt: defineMessage({ defaultMessage: 'Florida Keys Dive Center' }),
  },
  {
    title: defineMessage({ defaultMessage: 'Gili Shark Conservation, Indonesia' }),
    subtitle: defineMessage({ defaultMessage: 'Coral Reef Restoration' }),
    text: defineMessage(
      { defaultMessage: 'Providing coral conservation scholarships to Indonesian women to kickstart careers in marine conservation.' }),
    image: `${window.staticPath}travel_dist/images/offset-modal/women-team.jpg`,
    imageAlt: defineMessage({ defaultMessage: 'Gili Shark Conservation' }),
  },
  {
    title: defineMessage({ defaultMessage: 'Kosamare, Greece' }),
    subtitle: defineMessage({ defaultMessage: 'Climate Change' }),
    text: defineMessage(
      { defaultMessage: 'Conserving seagrass by installing permanent eco-moorings and sharing anchoring best practice with local yachting organizations.' }),
    image: `${window.staticPath}travel_dist/images/offset-modal/two-divers.png`,
    imageAlt: defineMessage({ defaultMessage: 'Kosamare, Greece' }),
  },
  {
    title: defineMessage({ defaultMessage: 'The Red Sea Project, Egypt' }),
    subtitle: defineMessage({ defaultMessage: 'Vulnerable Species Protection' }),
    text: defineMessage(
      { defaultMessage: 'Conserving endangered sea turtles through local awareness initiatives, diver education and surveying.' }),
    image: `${window.staticPath}travel_dist/images/offset-modal/turtle.jpg`,
    imageAlt: defineMessage({ defaultMessage: 'The Red Sea Project' }),
  },
]

export default function OffestDetailsPopup({
  isVisible,
  onClose,
}) {
  const { formatMessage } = useIntl()
  return (
    <PadiModal isOpen={isVisible} onClose={onClose}>
      <div className='offset-adventure-popup'>
        <FormattedMessage
          tagName='h2'
          defaultMessage='Want to Seek Adventure and Save the Ocean?'
          id='offset.title'
        />
        <FormattedMessage
          tagName='p'
          defaultMessage='The PADI AWARE Foundation’s Mission Hub Community Grant Program is a cornerstone initiative to accelerate participation, education, and advocacy for ocean protection. So far, PADI AWARE Foundation has provided critical resources to community projects across 15 countries - from coral reef restoration to climate change mitigation - and has made a commitment to provide over $5 million in funding by 2025.'
        />

        <FormattedMessage defaultMessage='With your help, we can reach even more local projects with global impact and achieve balance between humanity and ocean.' />

        <div className='text-center'>
          <iframe width='560'
            height='490'
            src='https://www.youtube.com/embed/kjneezUR8Pg?si=V3yT5VMOZ8iZYBcT'
            title='YouTube video player'
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;'
            allowFullScreen
          />
        </div>
        <FormattedMessage
          tagName='h4'
          defaultMessage='Why PADI AWARE Foundation? '
        />
        <FormattedMessage
          tagName='p'
          defaultMessage='For over 3 decades, PADI AWARE Foundation has elevated the voice of divers as a global force for good.'
        />
        <FormattedMessage
          tagName='p'
          defaultMessage='Together with the PADI Community, we have:'
        />
        <ul className='circled-list'>
          <FormattedMessage
            tagName='li'
            defaultMessage='Secured international protections for over 100 species of sharks and rays'
          />
          <FormattedMessage
            tagName='li'
            defaultMessage='Reported over 2 million pieces to the world’s largest underwater database on marine debris'
          />
          <FormattedMessage
            tagName='li'
            defaultMessage='Enabled 2 pioneering and critical scientific papers on marine debris'
          />
          <FormattedMessage
            tagName='li'
            defaultMessage='Educated over 1 million people about ocean conservation'
          />
          <FormattedMessage
            tagName='li'
            defaultMessage='Created the world’s largest network for marine conservation action, Adopt the Blue'
          />
        </ul>
        <FormattedMessage
          tagName='h4'
          defaultMessage='What is the PADI AWARE Community Grant Program?'
        />
        <FormattedMessage
          tagName='p'
          defaultMessage='The Community Grant Program provides PADI Dive Shops and small NGOs with up to $10,000 in direct funding for local projects that advance the PADI Blueprint for Ocean Action, supporting the global agenda to protect 30% of the ocean by 2030.'
        />
        <FormattedMessage
          tagName='p'
          defaultMessage=' Check out some examples below of projects who have already received support:'
        />
        <div className='projects'>
          {projectsInfo.map((project, index) => (
            <div className='project' key={index}>
              <div className='description'>
                <p className='project-title'>{formatMessage(project?.title)}</p>
                <p className='subtitle'>
                  {formatMessage(project?.subtitle)}
                </p>
                <p className='text'>
                  {formatMessage(project?.text)}
                </p>
              </div>
              <div className='project-image'>
                <img src={project?.image} alt={formatMessage(project?.imageAlt)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </PadiModal>
  )
}
